<template>
  <b-card>
    <FormBuilder
      label="Metode Pembayaran"
      update
      :data="$store.state.paymentMethod.detailData"
      :fields="fields"
      :loading-detail="$store.state.paymentMethod.loadingDetail"
      :loading-submit="$store.state.paymentMethod.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/payment-method'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('paymentMethod/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('paymentMethod/update', { id, data })
        .then(callback)
    },
    resetData() {
      return this.$store.commit('paymentMethod/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>

<style scoped>

</style>
